/**
 * createReducer()	- Reduces the clutter of massive switch statements by allowing a simple object of action:function()
 * @param  {mixed} initialState The Initial state of this given attribtue in the global store
 * @param  {object} handlers     The object-mapping list of functions to run through
 * @return {function|state}              Final state of the application after reducers are run
 */
function createReducer(initialState, handlers){
	return function(state = initialState, action){
		if(handlers.hasOwnProperty(action.type)) {
			return handlers[action.type](state, action);
		} else {
			return state;
		}
	};
}

export default createReducer;
